<template>
  <el-card v-if="po!=null && loadingSelectedPurchaseOrder == false" class="box grow scrollable only-y" :style="height" >
    <div class="" style="position:relative;float:right;z-index:1000">
      <el-button  type="primary" plain size="small" @click="editPo" :disabled="isEditDisabled()"><i class="el-icon-edit"></i></el-button>
      <!-- <el-button class="animated fadeInRight" type="primary" plain size="small"><i class="el-icon-message"></i></el-button> -->
      <el-dropdown size="small" class="ml-10">
        <el-button type="primary" size="small">
          {{$t('common.Actions')}}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="receivePO" v-if="(canShow({actualStatus:po.status, conditions:['ISSUED'], testedStatus:'RECEIVED'}) && !is_in_correction) || (inventory.code !=='IP' && po.status.code == 'TRANSMITTED')" :disabled="!$can('manage', 'PurchaseOrders')">
            {{ $t('purchase_orders.actions.receive') }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="openPRDialog(false)" v-if="canShow({ actualStatus:po.status, conditions:['ISSUED','IN_CORRECTION', 'PARTIAL_RECEIVED'], testedStatus:'PARTIAL_RECEIVED'}) || po.status.code=='PARTIAL_RECEIVED' || (inventory.code !=='IP' && po.status.code == 'TRANSMITTED')" :disabled="!$can('manage', 'PurchaseOrders')">
            {{ $t('purchase_orders.actions.partiallyReceive') }}
          </el-dropdown-item>
          <el-dropdown-item v-for="(customStatus, index) in customStatuses" :key="index" @click.native="handleCustomStatusAction(customStatus.action);" v-if="canShow({ customStatus, actualStatus:po.status, inventory })" :disabled="!$can('manage', 'PurchaseOrders')">
            {{$t('purchase_orders.custom_statuses.'+customStatus.action)}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="cancelInvoice" v-if="canShow({actualStatus:po.status, conditions:[], testedStatus:'CANCELLED'}) && po.status.code!=='CANCELLED'" :disabled="!$can('manage', 'PurchaseOrders') || po.status.weight > 16">
            {{$t('purchase_orders.actions.Cancel')}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="deletePo" v-if="po.status.code=='CANCELLED'" :disabled="!$can('manage', 'PurchaseOrders') ">
            {{ $t('purchase_orders.actions.delete') }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="createInvoice" v-if="po.status.code!='DRAFT' && isInvoicingModuleactive === true" :disabled="!$can('manage', 'PurchaseOrders')">
            {{ $t('purchase_orders.actions.charge') }}
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="duplicatePo">
            {{ $t('purchase_orders.actions.duplicate') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
    <el-row style="margin-bottom:10px;">
      <el-page-header @back="closePo()" style="float:left;">
        <div slot="title">
          <span class="hidden-sm-and-down"></span>
        </div>
        <div slot="content">
        <span class="fs-20">{{po.po_number}}</span>
        </div>
      </el-page-header>
    </el-row>

    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-info"></i> {{$t('purchase_orders.informations')}}</span>
        <el-row style="margin-left:10px;font-size:14px;" v-if="po!=null">
          <el-col>
            <span>{{$t('common.createdAtField')}} {{_moment(po.created_at, 'LLL')}} {{ $t('common.by') }} {{po.created_by.first_name}} {{po.created_by.last_name}}</span>
          </el-col>
          <el-col>
            <span>{{ $t('purchase_orders.responsibleField') }} {{po.accountant.first_name}} {{po.accountant.last_name}}</span>
          </el-col>
          <el-col>
            <span>{{$t('purchase_orders.details.date')}} {{_moment(po.date, 'LL')}}</span>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="el-icon-tickets"></i> {{$t('common.products')}}</span>
        <el-table
          :data="po.lines"
          border
          style="width: 100%"
          empty-text="Aucun item">
          <el-table-column
            label="Nom">
            <template slot-scope="scope">
              <productItemDefinition
                :product="scope.row.product"
                :name="scope.row.product.name"
                :sku="scope.row.product.sku"
                :product_unit="scope.row.product.unit"
                :product_uvc="scope.row.product.uvc"
                :reference="scope.row.reference"
                :description="scope.row.purchase_description"
                :customFields="scope.row.custom_fields" >
              </productItemDefinition>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('purchase_orders.qtyOrdered')">
            <template slot-scope="scope">
              <div v-if="calculateQuantityUVC">
                <span v-if="scope.row.product.unit == 1">{{Math.ceil(scope.row.qty_ordered/scope.row.product.uvc)}} {{$t(getProductUnit(scope.row.product.unit))}}(s)</span><br>
                <span>{{scope.row.qty_ordered}} Unité(s)</span>
              </div>
              <span v-else>{{scope.row.qty_ordered}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('purchase_orders.costPrice')">
            <template slot-scope="scope">
              <span>{{$n(scope.row.purchase_unit_price,'currency',currency)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('purchase_orders.margin')"
            v-if="marginEnabled">
            <template slot-scope="scope">
              <span>{{$t('purchase_orders.rateField')}} {{scope.row.margin_rate*100}}%</span><br>
              <span>{{$t('purchase_orders.amountField')}} {{$n(scope.row.margin,'currency',currency)}}</span><br>
              <span>{{$t('purchase_orders.totalField')}} {{$n(scope.row.margin+scope.row.purchase_unit_price,'currency',currency)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-loading="loadingSelectedPurchaseOrder">
        <span slot="label"><i class="el-icon-document-checked"></i> {{$t('purchase_orders.receptions')}}</span>
        <el-table
          :data="purchaseReceives"
          border
          style="width: 100%"
          v-loading="purchaseReceivesLoading"
          :empty-text="$t('purchase_orders.noReceptions')">
          <el-table-column type="expand">
             <template slot-scope="scope">
               <el-table :data="scope.row.products" style="width: 100%" stripe :cell-style="{padding:'2px'}" class="border">
                 <el-table-column
                   :label="$t('purchase_orders.receive.name')"
                   show-overflow-tooltip
                   fixed="left"
                   prop="name">
                 </el-table-column>
                 <el-table-column
                   :label="$t('purchase_orders.receive.reference')"
                   show-overflow-tooltip
                   prop="item.reference">
                 </el-table-column>
                 <el-table-column
                   :label="$t('purchase_orders.price')" width="120">
                     <template slot-scope="scope">
                       <span>{{$n(scope.row.item.price, 'currency','CAD')}}</span>
                     </template>
                 </el-table-column>
                 <el-table-column
                   :label="$t('purchase_orders.priceWithoutLicence')" width="160" v-if="inventory.code === 'IP'">
                     <template slot-scope="scope">
                       <span>{{$n(scope.row.item.priceTaxIn, 'currency','CAD')}}</span>
                     </template>
                 </el-table-column>
                 <el-table-column
                   label="Date d'arrivage" width="120">
                     <template slot-scope="scope">
                       <span>{{_moment(scope.row.item.availabilityDate,'L')}}</span>
                     </template>
                 </el-table-column>
                 <el-table-column width="45" align="center">
                   <template slot-scope="scope">
                     <el-button type="text" @click="openItemDrawer(scope.row.item.id)"><i class="el-icon-edit"></i></el-button>
                   </template>
                 </el-table-column>
               </el-table>
             </template>
           </el-table-column>
          <el-table-column
            label="#"
            width="150"
            align="center">
            <template slot-scope="scope">
                <el-popover
                placement="right"
                width="500"
                trigger="hover">
                <h3>{{scope.row.pr_number}}</h3>
                <span>{{$t('purchase_orders.receive.receiveByField')}} {{_moment(scope.row.date)}}</span><br>
                <span>{{ $t('common.byField') }} {{scope.row.created_by.first_name}} {{scope.row.created_by.last_name}}</span>
                <el-table :data="scope.row.products" style="width: 100%;margin-top:10px;margin-bottom:10px">
                  <el-table-column  property="name" :label="$t('purchase_orders.receive.name')"></el-table-column>
                  <el-table-column  property="qty_ordered" :label="$t('purchase_orders.qtyOrdered')"></el-table-column>
                  <el-table-column  property="qty" :label="$t('purchase_orders.qtyReceived')"></el-table-column>
                </el-table>
                <h4 v-if="scope.row.notes">Notes</h4>
                <span>{{scope.row.notes}}</span>
                <span slot="reference" style="cursor:pointer;">{{scope.row.pr_number}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('purchase_orders.receive.receiptDate')"
            width="180">
            <template slot-scope="scope">
              <span>{{_moment(scope.row.date)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('purchase_orders.receive.receiveBy')">
            <template slot-scope="scope">
              <span>{{scope.row.created_by.first_name}} {{scope.row.created_by.last_name}} </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="isInvoicingModuleactive === true">
        <span slot="label"><i class="el-icon-bank-card"></i> {{$t('purchase_orders.invoices')}}</span>
        <InvoiceTable :purchaseOrderId="selectedPurchaseOrder.id" :admin="true"></InvoiceTable>
      </el-tab-pane>
      <!-- <el-tab-pane>
        <span slot="label"><i class="el-icon-watch"></i> Historiques</span>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in selectedPurchaseOrderHistoricActivities"  :key="index" :icon="activity.icon" :color="activity.color">
            <div>
              <span style="">{{$t(activity.content)}}</span><br>
              <span style="color:#909399">{{_moment(activity.timestamp,'LL')}}</span>
            </div>
        </el-timeline-item>
      </el-timeline>
      </el-tab-pane> -->
    </el-tabs>

    <el-divider></el-divider>
    <!-- Début du détail du bon de commande -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">Fournisseur : </span>
          <span class="fs-14 secondary-text">
            <PortausLink v-if="selectedPurchaseOrder.vendor" path="/customers/" :id="selectedPurchaseOrder.vendor.id" :label="vendorName"></PortausLink>
          </span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">Statut : </span>
          <span class="fs-14 secondary-text">
            <el-tag :type="getTagTypeBasedOnStatus(po.status.code)" style="margin-left:10px;">{{$t("purchase_orders.statuses."+po.status.code)}}</el-tag>
            <el-tag v-if="po.billedStatus!=null" :type="getTagTypeBasedOnStatus(po.billedStatus.code)" style="margin-left:10px;">{{$t("purchase_orders.statuses."+po.billedStatus.code)}}</el-tag>
          </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{$t('purchase_orders.Reference')}} : </span>
          <span class="fs-14 secondary-text">{{po.reference}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <span class="fs-14 secondary-text">{{$t('purchase_orders.Reference2')}} : </span>
        <span class="fs-14 secondary-text">{{po.reference2}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{ $t('purchase_orders.expectedDeliveryDateField') }} </span>
          <span class="fs-14 secondary-text" v-if="po.reception_planning_date != null">{{_moment(po.reception_planning_date)}}</span>
      </el-col>
    </el-row>
    <el-divider/>
    <!-- détail des produits -->
    <el-table :data="po.lines" :empty-text="$t('purchase_orders.noProduct')" style="width:100%;">
      <el-table-column label="" width="60">
        <template slot-scope="scope" >
          <el-switch
            v-if="canShowCorrectionComponent(scope.$index)"
            :disabled="!$can('manage', 'PurchaseOrders')"
            :value="scope.row.in_correction"
            @change="v=>setInCorrection(scope.$index, v)"
            active-color="#ff4949"
            :active-value="true"
            :inactive-value="false">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="productLabel">
        <template slot-scope="scope">
          <productItemDefinition :product="scope.row.product" name="scope.row.product.name" :sku="scope.row.product.sku" :product_unit="scope.row.product.unit" :product_uvc="scope.row.product.uvc" :reference="scope.row.reference" :description="scope.row.purchase_description" :customFields="scope.row.custom_fields"></productItemDefinition>
        </template>
      </el-table-column>
      <el-table-column :label="quantityLabel" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="calculateQuantityUVC">
            <span v-if="scope.row.product.unit == 1">{{Math.ceil(scope.row.qty_ordered/scope.row.product.uvc)}} {{$t(getUnitFormatted(scope.row.product.unit))}}(s)<br></span>
            {{scope.row.qty_ordered}} Unité(s)
          </div>
          <div v-else>
            {{scope.row.qty_ordered}}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('purchase_orders.price')" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="marginEnabled">{{$n(scope.row.margin+scope.row.purchase_unit_price,'currency',currency)}}</span>
          <span v-else>{{$n(scope.row.purchase_unit_price,'currency',currency)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('purchase_orders.subTotal')" align="right" width="150">
        <template slot-scope="scope">
          {{$n(scope.row.total,'currency',currency)}}
        </template>
      </el-table-column>
    </el-table>
    <!-- fin du détail des produits-->
    <!-- début des totaux -->
    <el-row>
      <table style="width:100%;margin-top:20px;">
          <tr>
            <td class="fs-14 secondary-text" style="text-align:right;">{{$t('purchase_orders.subTotalField')}} </td>
            <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(po.sub_total,'currency',currency)}}</td>
          </tr>
          <tr>
            <td class="fs-14 secondary-text" style="text-align:right;">{{$t('purchase_orders.adjustmentField')}} </td>
            <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(po.adjustment,'currency',currency)}}</td>
          </tr>
          <tr>
            <td class="fs-14 secondary-text" style="text-align:right;">{{$t('purchase_orders.totalField')}} </td>
            <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(po.total,'currency',currency)}}</td>
          </tr>
      </table>
    </el-row>
    <!-- fin des totaux -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="po.notes!=null && po.notes!=''">
          <h5>Notes</h5>
          <span class="fs-14 secondary-text">{{po.notes}}</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="po.terms_conditions!=null && po.terms_conditions!=''">
        <h5>Termes et conditions</h5>
        <span class="fs-14 secondary-text">{{po.terms_conditions}}</span>
      </el-col>
    </el-row>
    <!-- Fin du détail du bon de commande -->
    <ItemDrawer :visible="itemDrawerVisible" :inventory="inventory" @close="closeItemDrawer" :edit="itemToEdit" @update="handleUpdateItem"></ItemDrawer>
    <PurchaseReceiveDialog :receiveAll="complete" :prDialogVisible.sync="prDialogVisible" :purchaseOrder="po" @close="closePRDialog" @created="purchaseReceiveCreated"></PurchaseReceiveDialog>
    <InvoiceEditor :visible="invoiceEditorVisible" :editInvoice="invoiceToCreate" @close="closeInvoiceEditor" @created="invoiceCreated"></InvoiceEditor>
  </el-card>
</template>
<script>
import PurchaseReceiveAPI from '@/services/API/purchase-receive'
import ItemAPI from '@/services/API/items'
import moment from 'moment-timezone'
import PurchaseReceiveDialog from './purchase-receive-dialog.vue'
import customStatusUtils from '@/utils/custom-status-utils'
import productUtils from '@/utils/portaus-utils'
import productItemDefinition from '@/components/product/product-item-definition'
import InvoiceEditor from '@/components/invoice/invoice-editor'
import ItemDrawer from '@/components/product/item-drawer'
import PortausLink from '@/components/portaus-link'
import InvoiceAPI from '@/services/API/invoice'

import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  name: 'Purchase-Order-View',
  props: {
		po : {type : Object},
	},
  data() {
    return {
      value : false,
      pdfCreating:false,
      window: {
        width: 0,
        height: 0
      },
      purchaseReceives : [],
      purchaseReceivesLoading : false,
      prDialogVisible : false,
      itemDialogVisible : false,
      itemToConfigure : null,
      complete : true,
      invoiceEditorVisible:false,
      invoiceToCreate : null,
      itemDrawerVisible : false,
      itemToEdit : null,

    };
  },components: {
    PurchaseReceiveDialog,
    productItemDefinition,
    InvoiceEditor,
    ItemDrawer,
    'InvoiceTable': () => import('@/components/invoice/invoice-table'),
    PortausLink,
  },
  watch : {
    po : function(val){
          this.listPurchaseReceives();
    }
  },
	methods: {
    openItemDrawer(itemId){
      return ItemAPI.getItem(itemId)
        .then(item=>{
          this.itemToEdit = item;
          this.itemDrawerVisible=true;
        })
    },
    closeItemDrawer(){
      this.itemDrawerVisible=false
    },
    handleUpdateItem(itemAdded){
      this.listPurchaseReceives();
    },
    promptInvoice(){
      return this.$confirm('Ce bon de commande a déjà été facturé. Voulez-vous facturé à nouveau ?', 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        })
    },
    convertToInvoice(){
      //On crée une instance de facture a partir du PO et ensuite on ouvre l'editeur de facture
      InvoiceAPI.convertPurchaseOrderToInvoice({ purchaseOrderId: this.selectedPurchaseOrder.id})
        .then((invoice) => {
          this.invoiceToCreate = invoice;
          this.openInvoiceEditor();
        }).catch((err) => {
          console.log(err);
        })
    },
    createInvoice(){
      if(this.isInvoiced){
        this.promptInvoice()
          .then(()=>{
            this.convertToInvoice();
          })
      }else{
          this.convertToInvoice();
      }

    },
    openInvoiceEditor(){
      this.invoiceEditorVisible=true;
    },
    setInCorrection(index, in_correction){
      this.setItemInCorrection({index, in_correction});
    },
    closeInvoiceEditor(){
      this.invoiceEditorVisible=false;
      this.invoiceToCreate=null;
    },
    invoiceCreated(invoiceId){
      this.closeInvoiceEditor();
      // this.markAsInvoiced();
    },
    openCustomer(customerId, tab=1){
      var index='/customers/'+customerId+"?activeTab="+tab;
      this.$router.push(index);
    },
		getUnitFormatted(unit){
			return productUtils.getFormattedUnit_i18n(unit);
		},
    cancelInvoice(){
      this.$confirm('Voulez-vous vraiment annulé ce bon de commande ?', 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.putSelectedPurchaseOrder('cancel')
            .then(()=>{
               this.$message.success('Le bon de commande a été annulé avec succès!');
            })
        }).catch(() => {

        });

    },
    getProductUnit(unit){
      return productUtils.getFormattedUnit_i18n(unit);
    },
    canShow({customStatus, actualStatus, conditions, testedStatus, inventory}){
      return customStatusUtils.canShow({customStatus, actualStatus, conditions, testedStatus, customStatuses:this.customStatuses, inventory});
    },
    inventoryItemUpdated(item){
      this.$store.dispatch('PURCHASE_ORDERS_CHANGE_ITEM_SELLING_INFO_PURCHASE_ORDER',item);
    },
    openPRDialog(complete=true){
      this.complete = complete;
      // console.log("receive all : ", this.complete);
      this.prDialogVisible=true;
    },
    closePRDialog(){
      this.prDialogVisible = false;
    },
    isEditDisabled(){
      return !this.$can('write', 'PurchaseOrders');
      return false;
      // return (this.po.status.code=='DRAFT'||this.po.status.code=='ISSUED'||this.po.status.code=='IN_PROCESS'||this.po.status.code=='CONFIRMED')?false:true;
    },
    purchaseReceiveCreated(info){
      this.listPurchaseReceives();
      this.refreshSelectedPurchaseOrder();
    },
    receivePO(){
      this.$confirm('Cette action indiquera que vous avez reçu en totalité tous les produits indiqués dans le bon de commande. Voulez-vous continuer?', 'Attention', {
            confirmButtonText: 'Oui',
            cancelButtonText: 'Annuler',
            type: 'warning'
          }).then(() => {
            this.openPRDialog();
          })
    },
    formatAmount(amount){
      return parseFloat(amount).toFixed(2);
    },
    calculatePOTotalAmount(po){
      return po.total_amount_items+po.adjustment;
    },
    duplicatePo(){
      // console.log("duplicatePo");
      this.$emit('duplicate',this.po);
    },
    editPo(){
      this.$emit('editPurchaseOrder',this.po);
    },
    deletePo(){
      this.$confirm('Ceci supprimera le bon de commmande de façon permanente. Voulez-vous continuer?', 'Attention', {
            confirmButtonText: 'Oui',
            cancelButtonText: 'Annuler',
            type: 'warning'
          }).then(() => {
            this.deleteSelectedPurchaseOrder()
              .then(()=>{
                this.$emit('deleted');
                this.$message({
                  type: 'success',
                  message: 'Le bon de commande a été supprimé'
                });
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: 'Suppression annulée'
            });
          });
    },
    closePo(itemId){
      this.$emit('close');
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleCustomStatusAction(action){
      if(action=='emit'){
        this.$confirm('Avez-vous entrer le(s) prix SAQ?', 'Warning', {
          confirmButtonText: 'Non, je veux les saisir',
          cancelButtonText: 'Oui, je veux émettre le BC',
          type: 'warning'
        }).then(()=>{
          this.editPo();

        }).catch(()=>{this.putSelectedPurchaseOrder(action);})
      }else{
        this.putSelectedPurchaseOrder(action);
      }
    },
    listPurchaseReceives(){
      this.purchaseReceivesLoading=true;

      return PurchaseReceiveAPI.list(this.po.id)
        .then(purchaseReceives=>{
          this.purchaseReceives=purchaseReceives;
          // this.buildHistoricActivities();
          this.purchaseReceivesLoading=false;
        })
    },
    ...mapActions('purchaseOrders', ['putSelectedPurchaseOrder','deleteSelectedPurchaseOrder','setItemInCorrection', 'refreshSelectedPurchaseOrder','setLoadingSelectedPurchaseOrder']),
    ...mapActions('invoiceEditor',['convertPurchaseOrderToInvoice']),
    ...mapActions('statuses', ['fetchPurchaseOrderStatuses', 'fetchInvoiceStatuses']),
    ...mapActions('inventoryProducts', ['fetchInventory'])
	},
	computed: {
    productLabel () {
      return `${this.$i18n.t('purchase_orders.product')} (${this.nbLines})`;
    },
    quantityLabel () {
      return `${this.$i18n.t('purchase_orders.quantity')} (${this.totalQuantities})`;
    },
    nbLines () {
      return this.selectedPurchaseOrder.lines.length;
    },
    totalQuantities (){
      let count = 0;
      _.forEach(this.selectedPurchaseOrder.lines, (l) => {
        count += l.qty_ordered;
      })
      return count;
    },
    poId() {
      return this.$route.params.purchaseOrderId;
    },
    inventoryId(){
			return this.$route.params.id;
		},
    isInvoiced(){
      let invoiced = false;
      if(this.selectedPurchaseOrder!=null && this.selectedPurchaseOrder.invoices!=null && this.selectedPurchaseOrder.invoices.length>0){
        _.forEach(this.selectedPurchaseOrder.invoices, i=>{
          if(i.code != 'VOIDED') invoiced=true;
        })
      }
      return invoiced;
    },
    currency(){
      return this.po.vendor!=null && this.po.vendor.currency!=null ? this.po.vendor.currency.code : 'CAD';
    },
    height(){
      return "height :"+(this.window.height-145) + "px"
    },
    marginEnabled(){
      return true;
      return localStorage.PURCHASE_ORDER_MARGIN=='1';
    },
    customStatuses(){
      if(localStorage.PURCHASE_ORDER_CUSTOM_STATUS==null)return [];
      return JSON.parse(localStorage.PURCHASE_ORDER_CUSTOM_STATUS);
    },
    calculateQuantityUVC(){
      return localStorage.CALCULATE_QUANTITY_UVC!=null&&localStorage.CALCULATE_QUANTITY_UVC==='1';
    },
    ...mapState('purchaseOrders',['selectedPurchaseOrder','selectedPurchaseOrderHistoricActivities','loadingSelectedPurchaseOrder']),
    ...mapGetters('purchaseOrders', ['getTagTypeBasedOnStatus', 'vendorName','is_in_correction','canShowCorrectionComponent']),
    ...mapState('inventoryProducts', ['inventory']),
    ...mapGetters(['isInvoicingModuleactive'])
	},
  mounted(){
    if(this.po!=null){
      this.listPurchaseReceives();
    }
  },
	created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.setLoadingSelectedPurchaseOrder(true);
    return Promise.all([
      this.fetchInventory(this.inventoryId),
      this.fetchPurchaseOrderStatuses(),
      this.fetchInvoiceStatuses(),
    ]).then(()=> {
      this.setLoadingSelectedPurchaseOrder(false);
    })

	},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.toolbar {
  max-width: 794px;
  margin: 0 auto;
  text-align: right;
  margin-bottom: 20px;
}

@media print
{
    .no-print, .no-print *
    {
        display: none !important;
    }
}

.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}


.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}


@media (max-width: 1024px) {

}
</style>
